import Axios from 'axios';
import moment from 'moment';

const axios = Axios.create({
	baseURL: '/api/c3'
});

function parseEta(item) {
	if(item.eta) {
		const date = moment(item.eta, 'DD-MM-YYYY');
		if(!isNaN(date)) {
			item.eta = date;
		}
	}
}

export function getCatalog(customer, catalog) {
	return axios.get(`/${encodeURIComponent(customer)}/${encodeURIComponent(catalog)}/catalog`).then(res => {
		return res.data;
	});
}

export function getItems(customer, catalog, skus) {
	return axios.post(`/${encodeURIComponent(customer)}/${encodeURIComponent(catalog)}/items`, { skus }).then(res => {
		res.data.forEach(parseEta);
		return res.data;
	});
}

export function checkout(customer, catalog, order) {
	return axios.post(`/${encodeURIComponent(customer)}/${encodeURIComponent(catalog)}/order`, order);
}
